import { provide, Ref, ref } from "vue";

export function providedRef<T>(key: string, defaultValue: T) {

  const theRef = ref<T>(defaultValue) as Ref<T>;
  provide(key, theRef)

  return theRef
}